import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { useGetStaticEquipment, useUpdateStaticEquipment } from "../api/api";
import { StaticEquipmentPartial } from "./StaticEquipmentPartial";
import type { ShipAndStaticEquipmentRouteProps } from "../types/routes";
import type { ApiError, StaticEquipment, StaticEquipmentForm } from "../types/models";

export const StaticEquipmentEdit = (props: ShipAndStaticEquipmentRouteProps) => {
  const { shipId, staticEquipmentId } = props.match.params;
  const history = useHistory();

  const { data: staticEquipment } = useGetStaticEquipment(
    shipId,
    staticEquipmentId
  ) as { data?: StaticEquipment };

  const [editedEquipment, setEditedEquipment] = useState<
    StaticEquipmentForm | undefined
  >();
  const [error, setError] = useState<ApiError | undefined>();

  useEffect(() => {
    if (!editedEquipment && staticEquipment) {
      const toDeckNumber = (value: unknown): number | "" => {
        if (typeof value === "number") {
          return value;
        }
        if (typeof value === "string") {
          const parsed = Number.parseInt(value, 10);
          return Number.isNaN(parsed) ? "" : parsed;
        }
        return "";
      };

      const next: StaticEquipmentForm = {
        position_on_deck_x: toDeckNumber(staticEquipment.position_on_deck?.x),
        position_on_deck_y: toDeckNumber(staticEquipment.position_on_deck?.y),
      };
      if (staticEquipment.type !== undefined) {
        next.type = staticEquipment.type;
      }
      if (staticEquipment.direction) {
        next.direction = staticEquipment.direction;
      }
      if (staticEquipment.station_name !== undefined) {
        next.station_name = staticEquipment.station_name;
      }
      if (staticEquipment.location !== undefined) {
        next.location = staticEquipment.location;
      }

      setEditedEquipment(next);
    }
    // eslint-disable-next-line
  }, [staticEquipment]);

  const updateStaticEquipment = useUpdateStaticEquipment(shipId, staticEquipmentId, {
    onSuccess: () => {
      history.push(`/ships/${shipId}/static-equipments/`);
    },
    onError: ((err: ApiError) => setError(err)) as () => void,
  }) as unknown as {
    mutate: (payload: StaticEquipmentForm | undefined) => void;
  };

  return (
    <StaticEquipmentPartial
      title="Edit static equipment"
      backLink={`/ships/${shipId}/static-equipments/`}
      submitButtonTitle="Save"
      editedEquipment={editedEquipment}
      error={error}
      setEditedEquipment={setEditedEquipment}
      onSubmitClick={() => {
        updateStaticEquipment.mutate(editedEquipment);
      }}
    />
  );
};
